import React, { memo } from 'react';
import classNames from 'classnames';
import cls from './TasksFilterTags.module.css';
import { Icon, MultiSelect } from '../../../shared/ui';
import { Tag } from '../model/tasksFilterTags';
import { useTranslation } from 'react-i18next';

interface TasksFilterTagsProps {
    classes: string;
    selectedTags: Tag[];
    tagsList: Tag[];
    deleteTag: (value: string) => void;
    changeSelectedTags: (value: string) => void;
    resetTags?: () => void;
}

export const TasksFilterTags = memo(
    ({
        selectedTags,
        tagsList,
        deleteTag,
        changeSelectedTags,
        classes,
        resetTags,
    }: TasksFilterTagsProps) => {
        const { t } = useTranslation();
        return (
            <>
                <MultiSelect
                    selectClasses={classNames({
                        [cls.activeSelect]: !!selectedTags.length,
                    })}
                    inputPlaceholder={t('Features.TasksFilterTags.MultiSelect.inputPlaceholder')}
                    classes={classes}
                    selected={selectedTags}
                    options={tagsList}
                    placeholder={t('Features.TasksFilterTags.MultiSelect.placeholder')}
                    deleteHandle={deleteTag}
                    onChange={changeSelectedTags}
                    showCheckboxes={true}
                    leftIcon={
                        <Icon
                            iconName={'taskTags'}
                            fill={!!selectedTags.length ? '#1094F7' : undefined}
                        />
                    }
                    onReset={!!selectedTags.length ? resetTags : undefined}
                    enableCreateTags={false}
                />
            </>
        );
    }
);
